export var headerStyle = {
    backgroundColor: 'var(--mui-palette-secondary-dark)',
    fontWeight: 600
};
export var customStyle = {
    backgroundColor: 'var(--mui-palette-common-white)',
    borderRadius: '12px'
};
